import { ReactComponent as IconSvg } from 'approot/shared/icons/icon_circle_cross.svg';
import Icon, { IconProps } from './icon';

const IconCircleCross = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconCircleCross;
